import { Condition } from "@redotech/redo-model/return-flow/condition";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export type DamagedState = boolean;

export const DAMAGED = (
  Details: React.ComponentType<ConditionTypeDetailsProps<DamagedState>>,
): ConditionType<DamagedState, Condition.Damaged> => ({
  name: "Damaged",
  description(state) {
    return "Return is for damaged product";
  },
  Details(props: ConditionTypeDetailsProps<DamagedState>) {
    return React.createElement(Details, props);
  },
  empty: false,
  fromModel(model) {
    return true; // This is a flag condition, always true when present
  },
  toModel(state) {
    return { type: Condition.DAMAGED };
  },
  valid(state) {
    return true;
  },
});
